import CustomToolTipComponent from '@modals/ModalAmpliaIntegral/ToolTipAI';


export const AIG = [
  { id: 1, description: 'Eliminación de deducible en pérdida total' },
  { id: 2, description: 'Auto sustituto por pérdida total' },
  { id: 3, description: 'Devolución de primas por pérdida total' },
  { id: 4, description: 'Responsabilidad civil privada-familiar' }
];

export const AXA = [
  {
    id: 1,
    description: 'Accidentes automovilisticos',
    tooltip: <CustomToolTipComponent title="Pago de porcentajes de suma asegurada en caso de accidente" />
  },
  {
    id: 2,
    description: 'Eliminación de deducible y devolución de primas',
    tooltip: <CustomToolTipComponent
      title="Se devolverá el monto pagado a la vigencia transcurrida de la fecha del siniestro de las  coberturas de Daños Materiales, Robo Total, Responsabilidad Civil por daños a terceros." />
  },
  {
    id: 3,
    description: 'Auto consentido',
    tooltip: <CustomToolTipComponent
      title="Se proporcionará al asegurado el uso de un vehículo en caso de Pérdida Total o Daños Materiales." />
  }
];

export const ABA = [
  {
    id: 1,
    description: 'Gastos médicos de los pasajeros $500,000',
    tooltip: <CustomToolTipComponent
      title="Cubre los gastos médicos para los pasajeros del coche en caso de accidente vial." />
  },
  {
    id: 2,
    description: 'CAP de Daños Materiales y Robo Total',
    tooltip: <CustomToolTipComponent
      title="En caso de Pérdida Total por Daños Materiales o Robo Total se pagará un % más de la suma asegurada." />
  },
  {
    id: 3,
    description: 'Cerocible Robo Total',
    tooltip: <CustomToolTipComponent
      title="En caso de Robo Total se indemnizará  con la suma asegurada sin pagar deducible." />
  },
  {
    id: 4,
    description: 'Cerocible',
    tooltip: <CustomToolTipComponent title="En caso de siniestro por colisión o vuelco amparado no pagas deducible." />
  },
  {
    id: 5,
    description: 'Robo de contenidos personales',
    tooltip: <CustomToolTipComponent
      title="Te cubre en caso de robo de pertenencias personales del interior del vehículo." />
  }
];

export const GNP = [
  {
    id: 1,
    description: 'Auto sustituto',
    tooltip: <CustomToolTipComponent
      title="Se proporcionará un auto sustituto una vez declarada la Pérdida Total por Daños Materiales o se haya hecho la denuncia de Robo Total hasta por 14 días." />
  },
  {
    id: 2,
    description: 'Daños materiales de llantas y/o rines',
    tooltip: <CustomToolTipComponent
      title="Cubre la reposición de llantas y/o reparación de rines, a través de talleres o proveedores autorizados." />
  },
  {
    id: 3,
    description: 'Reposición de llaves',
    tooltip: <CustomToolTipComponent
      title="Cubre el costo de reposición de las llaves y/o sus respectivos controles remotos como consecuencia de robo o extravío con un limite de $5,000 solo 1 evento." />
  },
  {
    id: 4,
    description: 'Cero deducible',
    tooltip: <CustomToolTipComponent
      title="Se exentará al asegurado del pago de deducible, para las coberturas de Daños Materiales Pérdida Total y Robo Total." />
  },
  {
    id: 5,
    description: 'Robo Parcial Plus',
    tooltip: <CustomToolTipComponent
      title="Tu seguro te cubrirá el robo de auto partes, pagando el deducible de la cobertura de robo total." />
  }
];


export const HDI = [
  {
    id: 1,
    description: 'Auto sustituto',
    tooltip: <CustomToolTipComponent
      title="Ampara la renta de un automóvil hasta 5 días días por cada año de vigencia en caso de detención legal, descompostura, perdida parcial o perdida total." />
  },
  {
    id: 2,
    description: 'Responsabilidad Civil Familiar',
    tooltip: <CustomToolTipComponent
      title="Ampara al asegurado cuando se encuentre como conductor de cualquier otro vehículo bajo las mismas condiciones de coberturas." />
  },
  {
    id: 3,
    description: 'Ayuda para gastos de transporte',
    tooltip: <CustomToolTipComponent
      title="Indemnización por $300 diarios hasta por 30 días cuando el vehículo sea declarado como Perdida Total o Robo Total." />
  }
];

export const MAPFRE = [
  {
    id: 1,
    description: 'Auto sustituto',
    tooltip: <CustomToolTipComponent
      title="Cobertura al asegurado con el uso de un vehículo sustituto en caso de Pérdida Total o Robo Total con un límite máximo de $10,000." />
  },
  {
    id: 2,
    description: 'Eliminación de deducible y devolución de primas',
    tooltip: <CustomToolTipComponent
      title="Indemnización sin el cobro del deducible.   Devolución en su totalidad de la prima neta e IVA por cada una de las coberturas amparadas." />
  },
  {
    id: 3,
    description: 'Accidentes al conductor',
    tooltip: <CustomToolTipComponent
      title="Queda amparado en caso de la pérdida de la vida o de miembros que sufra el conductor asegurado, o alguna otra persona que maneje el vehículo, siempre y cuando se haya ocasionado por un accidente hasta por $100,000." />
  },
  {
    id: 4,
    description: 'GAP',
    tooltip: <CustomToolTipComponent
      title="Cubre la diferencia  entre la cantidad del valor de la factura de su auto y lo que su seguro pagaría en caso de pérdida total por daños materiales y/o robo. Aplica sólo a vehículos con hasta 5 años de antigüedad." />
  }
];

export const PRIMEROSEGUROS = [
  {
    id: 1,
    description: 'Sin deducible en Pérdida Total por Daños Materiales',
    tooltip: <CustomToolTipComponent
      title="Te cubre lo que le pueda pasar a tu coche por accidentes viales cuando sea declarado pérdida total sin pagar deducible" />
  },
  {
    id: 2,
    description: 'Auto Sustituto',
    tooltip: <CustomToolTipComponent
      title="Cobertura al asegurado con el uso de un vehículo sustituto en caso de siniestro" />
  },
  {
    id: 3,
    description: 'Rededucible',
    tooltip: <CustomToolTipComponent
      title="Los deducibles aplicables a las coberturas de Daños Materiales serán menores cada renovación" />
  }
];

export const QUALITAS = [
  {
    id: 1,
    description: 'Responsabilidad Civil por daños a ocupantes',
    tooltip: <CustomToolTipComponent
      title="Ampara los gastos legales y las indemnizaciones que deriven de la Responsabilidad Civil que cause lesiones o muerte a terceros ocupantes del vehículo asegurado." />
  },
  {
    id: 2,
    description: 'Gastos de transporte por pérdida total',
    tooltip: <CustomToolTipComponent
      title="Cobertura al asegurado con el uso de un vehículo en caso de Pérdida Total." />
  },
  {
    id: 3,
    description: 'Cancelación de deducible de daños materiales por colisión o vuelco',
    tooltip: <CustomToolTipComponent
      title="Te cubre lo que le pueda pasar a tu coche por accidentes viales por colisión o vuelco sin pagar deducible." />
  },
  {
    id: 4,
    description: 'Muerte del conductor por accidentes automovilísticos',
    tooltip: <CustomToolTipComponent
      title="Te cubre toda lesión corporal que sufra el conductor en caso se siniestro." />
  }
];

export const ZURICH = [
  {
    id: 1,
    description: 'Perdida de objetos personales',
    tooltip: <CustomToolTipComponent
      title="Se ampara la pérdida que sufran los bienes u objetos personales del asegurado o de algún familiar: padre, madre, tutor e hijos y que habiten en el domicilio del asegurado, hasta por el límite de suma asegurada de $20,000." />
  },
  {
    id: 2,
    description: 'Multas y corralones',
    tooltip: <CustomToolTipComponent
      title="En caso de accidente de tránsito, se reembolsará el importe pagado por concepto de multas o infracciones, así como, el costo por pensión o corralón con un límite de suma asegurada de 45 UMA ($4,885.65)." />
  },
  {
    id: 3,
    description: 'Zero',
    tooltip: <CustomToolTipComponent
      title="Se realizará indemnización sin aplicar el deducible contratado en caso de declarar la Pérdida Total por Daños Materiales o Robo Total del vehículo asegurado." />
  }
  /*{ id: 4, description: 'Muerte al conductor por accidentes automovilisticos'}*/
];




